import { Page } from 'components';
import { useContext } from 'react';
import { Filters, Results } from './components';
import { qrCodeInfoContext } from './QrCodeCheckContext';


let QrCodeCheck = () => {
    let { isSearching } = useContext(qrCodeInfoContext);

    return (
        <Page
            useHeader={true}
            title="Qr Code informations"
            isLoading={isSearching}
        >
            <Filters />
            <Results />
        </Page>
    )
}

export default QrCodeCheck;